var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_38615",
    "data-name": "Group 38615",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14896",
    "data-name": "Rectangle 14896",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cloud-computing_1_",
    "data-name": "cloud-computing (1)",
    transform: "translate(1.5 3.757)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38614",
    "data-name": "Group 38614",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38613",
    "data-name": "Group 38613"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    id: "Path_33499",
    "data-name": "Path 33499",
    d: "M17.5,60.494A7.218,7.218,0,0,0,3.3,61.728a3.937,3.937,0,0,0,.656,7.822H7.234V68.237H3.953a2.625,2.625,0,0,1,0-5.249.656.656,0,0,0,.656-.656,5.906,5.906,0,0,1,11.7-1.148.656.656,0,0,0,.558.525,3.281,3.281,0,0,1-.446,6.529H13.8V69.55h2.625A4.593,4.593,0,0,0,17.5,60.494Z",
    transform: "translate(0 -55.032)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    id: "Path_33500",
    "data-name": "Path 33500",
    d: "M183.66,249.2l-2.625,2.625.925.925,1.509-1.5v6.293h1.312v-6.293l1.5,1.5.925-.925-2.625-2.625A.656.656,0,0,0,183.66,249.2Z",
    transform: "translate(-173.611 -241.056)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.e54a4ba906b07c27fde11bdd25fd656b.svg";
export { ForwardRef as ReactComponent };